import React from 'react'
import ReactLoading from 'react-loading'

const style = {
  loadingAnimation: {
    position: 'fixed', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)', 
    zIndex: '99',
  },
  dimmedScreen: {
    width: '100%', 
    height: '100%', 
    zIndex: '98', 
    background: '#444', 
    position: 'fixed', 
    left: '0', 
    top: '0', 
    opacity: '0.5',
  }
}

const Loading = ({isLoading=true}) => {
  if (isLoading === true) {
    return (
      <div>
        <div style={style.loadingAnimation}>
          <ReactLoading type='spin' color='#e5e5e5'/> {/* Loading State */}
        </div>
        <div style={style.dimmedScreen}
        ></div>
      </div>
    )
  } else return ''
}

export default Loading


// WEBPACK FOOTER //
// ./src/component/Loading.js